import Years from './Years';
import ConfigStore from './ConfigStore';

export default {
  config: new ConfigStore(),
  years: new Years(),
};
